/**
 * Sends a /ga/session request to the old express backend which
 * will create session info and store it in the redis database
 * so that it can push a purchase event to GA4 when it receives
 * a webhook from Centra.
 */
import { FrontendContextV1 } from "@made-people/nestjs-bff-service";
import { createMmBackendClient } from "./create-mm-backend-client";
import Cookies from "js-cookie";

// Produciton GA4 ID
const GA4_ID = "G-3PPYTRJV8E";

function getTrackingInfo({ url, headers }: { url: URL; headers: Headers }) {
  const query = Object.fromEntries(url.searchParams.entries());
  const isLandingPage =
    Object.keys(query).find(
      (key) => key === "gclid" || key.startsWith("utm_"),
    ) !== undefined;

  let landingPageUrl;
  if (isLandingPage) {
    landingPageUrl = new URL(`${url.origin}${url.pathname}`);
  }
  return {
    url: landingPageUrl?.toString(),
    headers: Object.fromEntries(headers.entries()),
  };
}

export function gaCreateSession(
  token: string,
  { url, headers }: { url: URL; headers: Headers },
  frontendContext: FrontendContextV1,
) {
  if (typeof window === "undefined") {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const theWindow = window as unknown as any;

  const delayInMilliseconds = 100;
  /**
   * Run retries for this number of milliseconds
   *
   * @type {number}
   */
  const maxRetryTimeInMilliseconds = 5 * 1000;

  // Set up client for backend API that also adds request context stuff
  const backendClient = createMmBackendClient(frontendContext);

  function sendToServer(retries: number) {
    const gtag = theWindow.gtag;
    const cookiebot = theWindow.Cookiebot;

    // Do not send tracking info if user has not accepted marketing or statistics cookies
    if (!(cookiebot?.consent?.marketing || cookiebot?.consent?.statistics)) {
      // return;
    }

    if (!gtag) {
      const totalRunTime = delayInMilliseconds * retries;
      if (totalRunTime > maxRetryTimeInMilliseconds) {
        console.debug(`window.gtag not found after ${totalRunTime} ms`);
        return;
      }
      setTimeout(() => sendToServer(retries + 1), delayInMilliseconds);
      return;
    }

    gtag("get", GA4_ID, "session_id", (sessionId: string) => {
      gtag("get", GA4_ID, "client_id", (clientID: string) => {
        if (!clientID) {
          console.error("GA client id not set");
          backendClient.delete("/ga/session").catch((error) => {
            console.error("GA: Failed to clear session", error);
          });
          return;
        }

        const trackingInfo = getTrackingInfo({ url, headers }) ?? {};

        const gbuuid = Cookies.get("gbuuid");

        // Set trackingInfo in backend
        backendClient
          .put(`/ga/session`, {
            ...trackingInfo,
            gaClientId: clientID,
            gaSessionId: sessionId,
            selectionId: token,
            gbuuid,
          })
          .catch((error) => {
            console.error("GA: Failed to set trackingInfo", error);
          });
      });
    });
  }

  sendToServer(0);
}
